import { useEffect } from 'react';

import { useAutoNavigate } from '@betterment/js-runtime';

export function useEchoEvents(): void {
  const autoNavigate = useAutoNavigate();

  useEffect(() => {
    const onNavigate = (event: CustomEvent<{ url: string }>) => {
      event.preventDefault();
      void autoNavigate(event.detail.url);
    };

    document.addEventListener('island:navigate', onNavigate);
    document.addEventListener('typed:redirect', onNavigate);

    return () => {
      document.removeEventListener('island:navigate', onNavigate);
      document.removeEventListener('typed:redirect', onNavigate);
    };
  }, [autoNavigate]);
}
